import styled from 'styled-components';
import { MarkerIcon } from '@rsos/assets/icons';
import { Button, Box } from '@rsos/base-components';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { getTokens } from '@rsos/sinatra';
import { useCurrentOrgName } from '@rsos/sinatra/src/selectors';
import { type SmartPhraseContext } from '@rsos/utils/SmartPhrases';

const RequestButton = styled(Button).attrs({
  btnType: 'invisible',
  noMargin: true,
  type: 'button',
})`
  height: auto;
  padding: 4px 2px;
`;

interface RequestLocationProps {
  onClick: (locationData: SmartPhraseContext) => void;
  isOutboundSMS?: boolean;
  disabled?: boolean;
}

const RequestLocation = ({
  onClick,
  isOutboundSMS = false,
  disabled = false,
}: RequestLocationProps) => {
  const tokens = getTokens();
  const orgName = useCurrentOrgName();
  const callerID = useSelectedCallerID() || '';

  return (
    <Box padding={isOutboundSMS ? '0' : '8px 16px 16px'}>
      <RequestButton
        onClick={() => onClick({ callerID, orgName, token: tokens?.token })}
        disabled={disabled}
      >
        <MarkerIcon height={12} width={12} />
        Request Location
      </RequestButton>
    </Box>
  );
};

export default RequestLocation;
